import {Basic} from "./Basic";
import {Browser} from "./Browser";
import {Display} from "./Display";
import {History} from "./History";

window.addEventListener('DOMContentLoaded',function()
{
    // set variables
    Basic.init();

    // get environment
    Browser.analyze();
    Display.analyze();

    // get language from HTML
    Basic.lang = document.documentElement.lang;

    // remove hover class on mobile devices
    if(Browser.mobile === true)
    {
        document.body.classList.remove('w__hover');
    }

    // add event listeners
    Basic.add_clickEvent();

    // add history listener
    History.replace_url();
    History.add_event();
});

// open details elements before print
window.addEventListener('beforeprint',() =>
{
    const allDetails = document.body.querySelectorAll('details');
    for(let i=0; i<allDetails.length; i++)
    {
        // mark details elements which are already open
        if(allDetails[i].open)
        {
            allDetails[i].dataset.open = '1';
        }
        // open details element
        else
        {
            allDetails[i].setAttribute('open', '');
        }
    }
});


// close details elements after print which were not open before
window.addEventListener('afterprint',() =>
{
    const allDetails = document.body.querySelectorAll('details');
    for(let i=0; i<allDetails.length; i++)
    {
        // remove marking
        if(allDetails[i].dataset.open)
        {
            allDetails[i].dataset.open = '';
        }
        // only close details elements which were not marked
        else
        {
            allDetails[i].removeAttribute('open');
        }
    }
});

// window resize detection
window.addEventListener('resize',() =>
{
    cancelAnimationFrame(Basic.resizeTimer);
    Basic.resizeTimer = requestAnimationFrame(Basic.process_resize);
});

// window resize detection
window.addEventListener('scroll',() =>
{
    cancelAnimationFrame(Basic.scrollTimer);
    Basic.scrollTimer = requestAnimationFrame(Basic.process_scroll);
});